import { Component, Input, OnInit } from '@angular/core';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';

@Component({
  selector: 'app-no-data-placeholder',
  templateUrl: './no-data-placeholder.component.html',
  styleUrls: ['./no-data-placeholder.component.css']
})
export class NoDataPlaceholderComponent implements OnInit {
  @Input() message: any;
  constructor(private _eventHandlingService:EventHandlingService) { }

  ngOnInit(): void {
  }

  ActionHandling(cta:any){
   
    this._eventHandlingService.changeAction(cta);
  }
  

}
